module.exports = {"id":"dp3_2l3q3","text":"Integrating and re-elaborating digital content","instructions":"Which method appropriately acknowledges reused digital content?","groupTitle":"Digital Profiler Knowledge Matrix","multiselect":false,"category":"3.2","questionType":"PickOne","random":true,"options":[{"id":"dp3_2l3q3-a1","text":"Including a clear citation or attribution","score":3.7},{"id":"dp3_2l3q3-a2","text":"Renaming the content file","score":1.3},{"id":"dp3_2l3q3-a3","text":"Changing colours and layout only","score":1.3}]}


//////////////////
// WEBPACK FOOTER
// ./src/constants/dp/questions/cat3.2/l3q3.json
// module id = 1137
// module chunks = 41